module.exports = __webpack_public_path__ + "static/media/anatomia.710f9468.png";